import React, { useState } from "react";
import { snakeToTitleCase, toTitleCase } from "services/employer.service";
import { Vacancy } from "services/types";
import DateLabel from "./date-label.component";
import PortalModal from "./portal-modal.component";

interface VacancyCardProps {
  vacancy: Vacancy
}

const VacancyCard: React.FC<VacancyCardProps> = ({ vacancy }) => {
  const [selectedVacancy, setSelectedVacancy] = useState<Vacancy>();
  const [show, setShow] = useState<boolean>(false);

  return (
    <>
      <div className="col-lg-4 col-md-6" key={vacancy.ref_id}>
        <div className="job-card">
          <div className="job-header">
            <i className="bi bi-gear-wide-connected"></i>
            <h4>{vacancy.job_type.name}, {toTitleCase(vacancy.rank.name)}</h4>
          </div>
          <p><i className="bi bi-building"></i> {vacancy.agency?.name}</p>
          <p><i className="bi bi-briefcase"></i> Experience: {vacancy.exp[0]} - {vacancy.exp[1]} year(s)</p>
          <p><i className="bi bi-calendar"></i> Posted: <DateLabel created_at={vacancy.created_at} /></p>
          <div className="d-flex justify-content-between">
            <button
              type="button"
              className="btn btn-indigo"
              onClick={() => {
                setSelectedVacancy(vacancy);
                setShow(true);
              }}
            >
              View Detail
            </button>
            <a
              href={`${process.env.REACT_APP_FRONTEND_PORTAL_URL}/#/verify-email?action=apply-vacancy&job_ref_id=${vacancy.ref_id}`}
              className="btn btn-indigo"
            >
              Apply Now
            </a>
          </div>
        </div>
      </div>
      <PortalModal show={show} onClose={() => setShow(false)} title="Job Details" >
        <dl className="row">
          <dt className="col-sm-3">Company</dt>
          <dd className="col-sm-9">{selectedVacancy?.agency?.name}</dd>
          <dt className="col-sm-3">Requested By</dt>
          <dd className="col-sm-9">{selectedVacancy?.requested_by}</dd>
          <dt className="col-sm-3">Contact No</dt>
          <dd className="col-sm-9">{selectedVacancy?.isd_code} - {selectedVacancy?.contact_no}</dd>

          {vacancy.nationalities && vacancy.nationalities.length > 0 && <>
            <dt className="col-sm-3">Nationalities</dt>
            <dd className="col-sm-9">
              {selectedVacancy?.nationalities.map((nationality: string, index: number) => (
                <span
                  key={index}
                  className="badge rounded-pill bg-primary me-2"
                >
                  {nationality}
                </span>
              ))}
            </dd>
          </>}

          <dt className="col-sm-3">Age</dt>
          <dd className="col-sm-9">{selectedVacancy?.age[0]} - {selectedVacancy?.age[1]} year(s)</dd>

          <dt className="col-sm-3">Experience</dt>
          <dd className="col-sm-9">{selectedVacancy?.exp[0]} - {selectedVacancy?.exp[1]} year(s)</dd>

          {selectedVacancy?.day_rate && <>
            <dt className="col-sm-3">Day Rate</dt>
            <dd className="col-sm-9">$ {selectedVacancy?.day_rate}</dd>
          </>}

          {selectedVacancy?.rotation && <>
            <dt className="col-sm-3">Rotation</dt>
            <dd className="col-sm-9">{selectedVacancy?.rotation} Day(s)</dd>
          </>}

          {selectedVacancy?.contract_type && <>
            <dt className="col-sm-3">Contract Type</dt>
            <dd className="col-sm-9">{snakeToTitleCase(selectedVacancy?.contract_type)}</dd>
          </>}
        </dl>
      </PortalModal>
    </>
  )
}

export default VacancyCard;
